/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  FunnelIcon, PencilIcon, PlusCircleIcon, PlusIcon,
} from "@heroicons/react/20/solid";
import { useAuthInfo } from "@propelauth/react";
import { useMutation } from "@tanstack/react-query";
import {
  useCallback,
  useMemo, useState, useRef, useEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Divider, Flex, Menu, Text, Select, Modal, Group,
  ActionIcon,
} from "@mantine/core";
import uuid from "react-uuid";
import {
  IconBolt, IconCirclePlus, IconFileExport, IconSettings, IconDeviceFloppy,
} from "@tabler/icons-react";
import { queryClient, useCreateExport } from "../../../../hooks/QueryHooks";
import {
  createView,
  updateViewInApi,
} from "../../../../services/view/viewEndpoints";
import FilterContainer from "../../../../shared/filter/FilterContainer";
import HeButton from "../../../../shared/ui/buttons/HeButton";
import MultiSelectDropdown from "../../../../shared/ui/dropdown/MultiSelectDropdown";
import isEqual from "lodash/isEqual";
import SortDropdown from "../../../../shared/ui/dropdown/SortDropdown";
// BasicSelect now replaced with Mantine Select
import useViewStore from "../../../../store/view/viewStore";
import useWorkspaceStore from "../../../../store/workspace/workspaceStore";
import notify from "../../../../utils/notify";
import { getLargerTimeWindow } from "../../../../utils/dateConverter";
import SignalFilterContainer from "../../signals/signal-overview/components/SignalFilterContainer";
import CreateView from "../../components/CreateView";
import MButton from "../../../../shared/ui/buttons/MButton";
import useSignalStore from "../../../../store/signal/signalStore";
import { SaveAllIcon } from "lucide-react";

type Props = {
  count: number;
  currentView: any;
  traits?: any;
  metrics?: any;
};

const AccountControls = ({
  count,
  currentView,
  traits,
  metrics,
}: Props) => {
  const [create, setCreate] = useState(false);
  const [showSavePrompt, setShowSavePrompt] = useState(false);
  const {
    updateView, addPredicate, editPredicate, deletePredicate,
    setMetrics, setTimeWindow, setSelectedFields, addFilter, deleteFilter,
  } = useViewStore();
  
  // Keep a snapshot of the last _saved_ version of the view
  const lastSavedRef = useRef<any>(currentView);

  // Update baseline immediately if the view id changes
  if (currentView && lastSavedRef.current?.id !== currentView.id) {
    lastSavedRef.current = currentView;
  }

  // Determine if anything has changed compared with the last saved snapshot
  const hasUnsavedChanges = useMemo(() => {
    if (!currentView) return false;
    return !isEqual(currentView, lastSavedRef.current);
  }, [currentView, lastSavedRef.current]);
  const [showFilter, setShowFilter] = useState(true);
  const [showHidden, setShowHidden] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const { user } = useAuthInfo();
  const currentWorkspace = useWorkspaceStore((state) => state.workspace);
  const navigate = useNavigate();

  const timeframes = useMemo(() => ([
    "Today",
    "Yesterday",
    "Last 7 days",
    "Last 30 days",
    "Last 90 days",
    "Last 180 days",
    "Last 365 days",
    "All time",
  ]).map((key, id) => ({ id: id + 1, label: key, name: key.toLowerCase().split(" ").join("_"), value: key.toLowerCase().split(" ").join("_") })), []);

  const createViewMutation = useMutation({
    mutationFn: createView,
  });

  const updateViewMutation = useMutation({
    mutationFn: updateViewInApi,
  });

  const selectedTimeFrame = useMemo(
    () => timeframes.find((item) => item.name === currentView?.metrics_time_frame) || timeframes[0],
    [currentView?.metrics_time_frame],
  );

  const selectedColumns = useMemo(
    () => currentView?.selected_columns || [],
    [currentView?.selected_columns],
  );

  const selectedMetrics = useMemo(
    () => currentView?.metrics || [],
    [currentView?.metrics],
  );

  const sort = useMemo(
    () => {
      const selectedSort = { ...traits?.obj, ...metrics?.obj }[currentView?.sort_fields?.field];
      return {
        name: selectedSort?.display_name,
        type: selectedSort?.data_type,
        entityType: selectedSort?.attribute_type,
        value: selectedSort?.name,
      };
    },
    [currentView?.sort_fields?.field, traits],
  );

  const sortDir = useMemo(
    () => ({ order: currentView?.sort_fields?.order, type: currentView?.sort_fields?.type }),
    [currentView?.sort_fields?.order, traits],
  );

  const filteredTraits = useMemo(
    () => traits?.list?.filter((item: any) => !item.exclude_display),
    [metrics?.list?.length],
  );

  const filteredMetrics = useMemo(
    () => metrics?.list?.filter((item: any) => !item.exclude_display),
    [metrics?.list?.length],
  );

  const handleOpenFilters = () => {
    setShowFilter((state) => !state);
    setShowHidden(false);
    setShowSort(false);
  };

  const handleNewView = (name: string, type: string, isPublic: string) => {
    createViewMutation.mutate({
      ...currentView,
      filters: { ...currentView?.filters, predicates: currentView?.filters?.predicates?.filter((item: any) => item.field !== "") },
      owner_id: user?.userId,
      workspace_id: currentWorkspace?.id,
      view_name: name,
      is_public: isPublic,
      is_precreated: false,
    }, {
      onSuccess: (data: any) => {
        queryClient.setQueryData(["views", currentWorkspace.id], (oldData: any) => ({
          ...oldData,
          data: {
            ...oldData.data,
            views: [...oldData.data.views,
              data?.data,
            ],
          },
        }));
        if (process.env.REACT_APP_HE_WORKSPACE_KEY && process.env.REACT_APP_HE_DATA_KEY) {
          window?.hyperengage(
            "track",
            "new_view_created",
            {
              properties: {
                view_name: name,
                workspace_id: currentWorkspace?.id,
                owner_id: user?.userId,
                is_public: isPublic,
              },
            },
          );
        }
        notify({
          type: "success",
          messageList: ["View created successfully"],
        });
        navigate(`/home/${currentWorkspace?.unique_identifier}/view/${data?.data?.id}`);
      },
      onError: (error: any) => {
        if (error.response?.status !== 0) {
          notify({
            heading: "Unknown error.",
            type: "failure",
            messageList: [
              "An unknown error occurred while creating the new view. Please try again later or contact our support team for assistance.",
            ],
          });
        }
      },
    });
  };

  const handleViewSave = () => {
    updateViewMutation.mutate({
      ...currentView,
      filters: { ...currentView?.filters, predicates: currentView?.filters?.predicates?.filter((item: any) => item.field !== "") },
      owner_id: user?.userId,
      workspace_id: currentWorkspace.id,
    }, {
      onSuccess: (data: any) => {
        queryClient.setQueryData(["views", currentWorkspace.id], (oldData: any) => ({
          ...oldData,
          data: {
            ...oldData.data,
            views: oldData?.data?.views
              ?.map((item: any) => (item.id === data?.data?.id ? data?.data : item)),
          },
        }));
        lastSavedRef.current = data?.data; // update baseline after successful save
        if (process.env.REACT_APP_HE_WORKSPACE_KEY && process.env.REACT_APP_HE_DATA_KEY) {
          window?.hyperengage(
            "track",
            "view_updated",
            {
              properties: {
                view_name: currentView?.view_name,
                is_public: currentView?.is_public,
                workspace_id: currentWorkspace?.id,
                entity_type: currentView?.entity_relation,
              },
            },
          );
        }
        notify({
          type: "success",
          messageList: ["View updated successfully"],
        });
      },
      onError: (error: any) => {
        if (error.response?.status !== 0) {
          notify({
            heading: "Unknown error.",
            type: "failure",
            messageList: [
              "An unknown error occurred while creating the new view. Please try again later or contact our support team for assistance.",
            ],
          });
        }
      },
    });
  };

  const { setAllFilters, setName } = useSignalStore();

  const handleNewSignal = () => {
    setName(currentView?.name);
    setAllFilters(
      currentView?.filters,
    );
    navigate(`/home/${currentWorkspace?.unique_identifier}/signals/new`);
  };

  const createExportMutation = useCreateExport();

  const initiateExport = () => {
    if (!currentView?.id) {
      notify({ 
        heading: 'Error', 
        messageList: ['No view selected for export'], 
        type: 'failure' 
      });
      return;
    }

    createExportMutation.mutate({
      workspace_id: currentWorkspace?.id,
      view_id: currentView.id,
    }, {
      onSuccess: () => {
        notify({ 
          heading: 'Export initiated', 
          messageList: ['Your export is being processed. You can view it in the Exports page.'], 
          type: 'success' 
        });
      },
      onError: (error: any) => {
        notify({ 
          heading: 'Export failed', 
          messageList: [error?.response?.data?.message || 'An error occurred while processing your export'], 
          type: 'failure' 
        });
      }
    });
  };
  
  const handleExport = () => {
    // If it's the default view, export directly without showing save prompt
    if (currentView?.is_precreated) {
      initiateExport();
    } else if (hasUnsavedChanges) { // If view is precreated (not default) or has unsaved changes, show save prompt
      setShowSavePrompt(true);
    } else {
      // Otherwise proceed with export
      initiateExport();
    }
  };

  const handleSaveAndExport = () => {
    handleViewSave();
    setShowSavePrompt(false);
    // Export will be initiated after successful save
    initiateExport();
  };

  const handleHidden = () => {
    setShowHidden((state) => !state);
    setShowFilter(false);
    setShowSort(false);
  };

  const handleSort = () => {
    setShowSort((state) => !state);
    setShowFilter(false);
    setShowHidden(false);
  };

  const handleTimeFrame = (timeframe: any) => {
    updateView({
      metrics_time_frame: timeframe?.name,
    });
  };

  const handleFilterAdd = () => {
    const filters = currentView
      ?.filters?.predicates?.length ? currentView?.filters
        ?.predicates[currentView.filters.predicates.length - 1]?.predicates : [];
    if (filters?.length === 0 || filters[0].field !== "") {
      addFilter({
        query_type: "AND",
        predicates: [{
          field: "",
          operator: "",
          value: undefined,
          type: "",
          entity_type: "column",
        }],
      });
    }
  };

  const handlePredicateAdd = (filterId?: any) => {
    const filt = currentView?.filters?.predicates[filterId]?.predicates;
    if (filt?.length === 0 || filt[filt.length - 1].field !== "") {
      addPredicate(
        {
          field: "",
          operator: "",
          value: undefined,
          type: "",
          entity_type: "column",
        },
        filterId,
      );
    }
  };

  const handlePredicateClear = (filterId?: any) => {
    deleteFilter(filterId);
  };

  const handlePredicateChange = (
    field: string,
    operator: string,
    value: any,
    type: string,
    entity_type: string,
    arrayId: number,
    filterId: number,
    time_window?: string,
  ) => {
    editPredicate({
      field,
      operator,
      value,
      type,
      entity_type: entity_type || "column",
      time_window,
    }, arrayId, filterId);
    if (field !== "") {
      let newColumns: any = [];
      const newMetrics: any = (!selectedMetrics.includes(field) && entity_type !== "column" && field !== "") ? [...selectedMetrics, field] : selectedMetrics;
      if (currentView?.entity_relation === "accounts" && field?.startsWith("accounts.")) {
        newColumns = (!selectedColumns.includes(field) && entity_type === "column") ? [...selectedColumns, field] : selectedColumns;
        setSelectedFields(newColumns);
      } else if (currentView?.entity_relation === "users" && field?.startsWith("users.")) {
        newColumns = (!selectedColumns.includes(field) && entity_type === "column") ? [...selectedColumns, field] : selectedColumns;
        setSelectedFields(newColumns);
      }
      setMetrics(newMetrics);
      setTimeWindow(getLargerTimeWindow(currentView?.metrics_time_frame, time_window));
    }
  };

  const handlePredicateRemove = (id: number, filterId?: any) => {
    deletePredicate(id, filterId);
  };

  const onSelectSort = useCallback(
    (field: any, dir: any) => {
      updateView({
        sort_fields: { field: field?.value, order: dir?.order, type: dir?.type || "property" },
      });
    },
    [currentView],
  );

  const onSelectColumn = (item: any) => {
    if (item.attribute_type === "metric_traits") {
      updateView({
        ...currentView,
        metrics: selectedMetrics.includes(item.name)
          ? selectedMetrics.filter((name: any) => name !== item.name)
          : [...selectedMetrics, item.name],
      });
    } else {
      updateView({
        ...currentView,
        selected_columns: selectedColumns.includes(item.name)
          ? selectedColumns.filter((name: any) => name !== item.name)
          : [...selectedColumns, item.name],
      });
    }
  };

  return (
    <>
      <div className="sm:flex items-center justify-between px-5 py-3 ">
        <div className="sm:flex-auto items-center">
          <Group gap="sm">
            <h3 className="text-[14px] font-normal text-gray-800 font-bold italic">
              {count}
              {" "}
              {currentView?.entity_relation || "accounts"}
              {" "}
              with Profiles
            </h3>
          </Group>
        </div>
        <div className="flex gap-2 justify-end flex-wrap lg:flex-nowrap items-center">
        {(hasUnsavedChanges) && (
              <Button
                size="xs"
                variant="light"
                color="blue"
                leftSection={<SaveAllIcon size={12} />}
                onClick={currentView?.is_precreated ? () => setCreate(true) : handleViewSave}
              >
                Save View
              </Button>
            )}
          <Button
            size="xs"
            variant="white"
            onClick={handleOpenFilters}
            leftSection={<FunnelIcon width={12} height={12} />}
            rightSection={
              currentView?.filters?.predicates?.length
                ? ` (${currentView?.filters?.predicates?.length})`
                : ""
            }
          >
            Filter
          </Button>
          <MultiSelectDropdown
            selected={[...selectedColumns, ...selectedMetrics]}
            setSelected={onSelectColumn}
            isOpen={showHidden}
            setIsOpen={setShowHidden}
            list={filteredTraits}
            metricsList={filteredMetrics}
            position="bottom-end"
          >
            <div>
              <Button
                size="xs"
                variant="white"
                onClick={handleHidden}
                leftSection={<PencilIcon width={12} height={12} />}
              >
                {`Edit Columns ${
                  currentView?.selected_columns?.length
                    ? ` (${
                      currentView?.selected_columns?.filter(
                        (item: any) => !traits?.obj[item]?.exclude_display,
                      ).length
                    })`
                    : ""
                }`}
              </Button>
            </div>
          </MultiSelectDropdown>

          {sort?.name && (
          <SortDropdown
            selectedColumns={[...selectedColumns, ...selectedMetrics, "last_seen"]}
            selectSort={sort}
            selectSortDir={sortDir}
            isOpen={showSort}
            setIsOpen={setShowSort}
            list={[...filteredTraits, ...filteredMetrics]}
            onDone={onSelectSort}
          >
            <Button
              size="xs"
              variant="white"
              onClick={handleSort}
            >
              {`Sort: ${
                traits?.obj ? { ...traits.obj, ...metrics.obj }[sort?.value]?.display_name : ""
              }`}
            </Button>
          </SortDropdown>
          )}
            <Select
              size="xs"
              w="110px"
              placeholder="Timeframe"
              value={selectedTimeFrame?.name}
              onChange={(value) => {
                const timeframe = timeframes.find(item => item.name === value);
                if (timeframe) handleTimeFrame(timeframe);
              }}
              data={timeframes.map(item => ({
                value: item.name,
                label: item.label
              }))}
            />
            <Menu shadow="md" position="bottom-end" width={200}>
              <Menu.Target>
                <ActionIcon
                  size="md"
                  variant="light"
                  color="gray.6"
                  className="!border !border-gray-300"
                >
                  <IconSettings size={14} />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item
                  leftSection={<IconCirclePlus size={14} />}
                  onClick={currentView?.is_precreated ? () => setCreate(true) : handleViewSave}
                >
                  {currentView?.is_precreated ? "Create View" : "Save View"}
                </Menu.Item>
                <Menu.Item
                  leftSection={<IconFileExport size={14} />}
                  onClick={handleExport}
                >
                  Export CSV
                </Menu.Item>
                <Menu.Item
                  leftSection={<IconBolt size={14} />}
                  onClick={handleNewSignal}
                >
                  Create Signal
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
        </div>
      </div>
      {showFilter && (
      <div className="px-4">
        {currentView?.filters?.predicates?.map((filter: any, index: number) => (
          <>
            <SignalFilterContainer
              key={index + currentView.entity_relation}
              entityRelation={currentView?.entity_relation}
              time_window={currentView?.metrics_time_frame}
              selectedFilters={filter.predicates}
              handleAdd={handlePredicateAdd}
              handleClear={handlePredicateClear}
              handleRemove={handlePredicateRemove}
              handleFilter={handlePredicateChange}
              filterId={index}
            />
            {currentView?.filters?.predicates?.length === index + 1 ? null : (
              <Flex h={50} key={uuid()} direction="column" align="center" justify="center">
                <Divider w={2} className="mx-auto" orientation="vertical" size="lg" h={15} />
                <Text size="xs" c="text.4" fw={600}>- OR -</Text>
                <Divider w={2} className="mx-auto" orientation="vertical" size="lg" h={15} />
              </Flex>
            )}
          </>
        ))}
        <Flex pb={10} className="mt-4" justify="flex-start">
          <Button
            size="xs"
            variant="subtle"
            color="purple"
            onClick={() => { handleFilterAdd(); }}
            leftSection={<PlusIcon className="flex-shrink-0 h-4 w-4" />}
          >
            Add Condition Group
          </Button>
        </Flex>
      </div>
      )}

      {/* Save before export prompt */}
      <Modal
        opened={showSavePrompt}
        onClose={() => setShowSavePrompt(false)}
        title="Save changes before export"
        size="sm"
      >
        <Text size="sm" mb={20}>
          You have unsaved changes to this view. Would you like to save the changes before exporting?
        </Text>
        <Flex gap="md" justify="flex-end">
          <Button 
            variant="outline" 
            color="gray" 
            onClick={() => {
              setShowSavePrompt(false);
              initiateExport();
            }}
          >
            Export without saving
          </Button>
          <Button 
            variant="default"
            onClick={handleSaveAndExport}
          >
            Save and Export
          </Button>
        </Flex>
      </Modal>
      {create && (
        <CreateView
          open={create}
          onClick={handleNewView}
          setOpen={setCreate}
          defaultType={currentView?.entity_relation === "accounts" ? "accounts" : "users"}
          disableType
        />
      )}
    </>
  );
};

export default AccountControls;
